import { render, staticRenderFns } from "./vertical-list.vue?vue&type=template&id=29a961b0&scoped=true&"
import script from "./vertical-list.vue?vue&type=script&lang=js&"
export * from "./vertical-list.vue?vue&type=script&lang=js&"
import style0 from "./vertical-list.vue?vue&type=style&index=0&id=29a961b0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a961b0",
  null
  
)

export default component.exports